import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMemberValidated: false,
    memberValidationData: {
      memberIdentifier: '',
      birthDate: ''
    },
    memberData: {
      firstName: '',
      lastName: '',
      phone: '',
      memberNumber: '',
      address: {
        city: '',
        state: '',
        street: '',
        street2: '',
        zipcode: ''
      }
    },
    loginCredentials: {
      username: '',
      password: '',
      email: ''
    },
    securityQuestionCatalog: [],
    securityQuestionSelection: {
      id: '',
      answer: ''
    }
  },
  mutations: {
    setMemberValidationStatus (state, newStatus) {
      state.isMemberValidated = newStatus
    },

    setMemberValidationData (state, data) {
      state.memberValidationData = data
    },

    setMemberData (state, memberData) {
      state.memberData = memberData
    },

    setLoginCredentials (state, loginCredentials) {
      state.loginCredentials = loginCredentials
    },

    setEmailAddress (state, email) {
      state.loginCredentials.email = email
    },

    setSecurityQuestionSelection (state, securityQuestionSelection) {
      state.securityQuestionSelection = securityQuestionSelection
    },

    setSecurityQuestionCatalog (state, securityQuestionCatalog) {
      state.securityQuestionCatalog = securityQuestionCatalog
    }
  },
  getters: {
    getIsMemberValidated: state => {
      return state.isMemberValidated
    },

    getMemberValidationData: state => {
      return state.memberValidationData
    },

    getMemberData: state => {
      return state.memberData
    },

    getLoginCredentials: state => {
      return state.loginCredentials
    },

    getEmailAddress: state => {
      return state.loginCredentials.email
    },

    getSecurityQuestionCatalog: state => {
      return state.securityQuestionCatalog
    },

    getSecurityQuestionSelection: state => {
      return state.securityQuestionSelection
    }
  }
})



// WEBPACK FOOTER //
// ./src/Store.js